/**
 * ocr_status table values
 */
export const OcrStatus = class {
    public static readonly WAITING_FOR_CLIENT = 1;
    public static readonly QUEUED_AT_CLIENT = 2;
    public static readonly JOB_COMPLETE = 3;
    public static readonly NOTHING_TO_DO = 4;
}

/**
 * ocr_job table values
 */
export const OcrJob = class {
    public static readonly EXTRACT_CATEGORY_DATA = 1;
    public static readonly EXTRACT_HEADER_AND_LINE_ITEM_DATA = 2;
    public static readonly EXTRACT_ALL_DOCUMENT_DATA = 3;
    public static readonly MISSING_CONFIGURATION = 5;
    public static readonly USER_DISCARD = 6;
    public static readonly OCR_DISCARD = 7;
    public static readonly REQUEST_RESCAN = 8;
    public static readonly SEND_TO_ALLOCATOR = 9;
    public static readonly OCR_COMPLETE = 10;
    public static readonly OCR_ERROR = 11;
    public static readonly SUPPLIER_COPY = 12;
    public static readonly EDI = 13;
    public static readonly DUPLICATE_TO_BE_CONFIRMED = 14;
    public static readonly DUPLICATE_CONFIRMED = 15;
    public static readonly EZESCAN_ERROR = 16;
    public static readonly DATA_UPLOAD_ERROR = 17;
    public static readonly LATE_SUPPLIER_COPY = 18;
    public static readonly DOCUMENT_NUMBER_REGEX = 21;
    public static readonly EXTRACT_STATEMENT_HEADER_AND_LINE_ITEM_DATA = 23;
}

/**
 * field table
 */
export const OcrField = class {
    public static readonly ABN = 1;
    public static readonly DOCUMENT_TYPE = 2;
    public static readonly DOCUMENT_NUMBER = 3;
    public static readonly PURCHASE_ORDER_NUMBER = 4;
    public static readonly DOCUMENT_DATE = 5;
    public static readonly DELIVERY_DATE = 6;
    public static readonly DOCUMENT_TOTAL = 7;
    public static readonly DOCUMENT_GST = 8;
    public static readonly FREIGHT = 9;
}

/**
 * source_type table
 */
export const SourceType = class {
    public static readonly STORE_SCAN = 1;
    public static readonly STORE_EMAIL = 2;
    public static readonly SUPPLIER_EMAIL = 3;
}
/**
 * document_type table
 */
export const DocumentTypeCode = class {
    public static readonly TAX_INVOICE = "I";
    public static readonly CREDIT_NOTE = "C";
    public static readonly DELIVERY_DOCKET = "D";
    public static readonly STATEMENT = "S";
}

/**
 * ocr_channel table
 */
export const OcrChannel = class {
    public static readonly EZE_SERVER = 1;
    public static readonly EZE_MANUAL = 2;
    public static readonly ALLOCATOR = 3;
    public static readonly CLICK = 4;
    public static readonly WEB_UI = 5;
    public static readonly WEB_UI_ADMIN = 6;
}

/**
 * document_match_type table
 */
export const DocumentMatchType = class {
    public static readonly STORE_COPY_OF = 1;
    public static readonly SUPPLIER_COPY_OF = 2;
    public static readonly DUPLICATE_OF = 3;
    public static readonly RESCAN_OF = 4;
    public static readonly LATE_SUPPLIER_COPY_OF = 5;
}

/**
 * document_rescan_status table
 */
export const RescanStatus = class {
    public static readonly WAITING_FOR_RESCAN = 1;
    public static readonly RESCAN_RECEIVED = 2;
    public static readonly ORIGINAL_DISCARDED = 3;
}

export const HttpStatus = class {
    public static readonly CONTINUE = 100;
    public static readonly SWITCHING_PROTOCOLS = 101;
    public static readonly PROCESSING = 102;
    public static readonly OK = 200;
    public static readonly CREATED = 201;
    public static readonly ACCEPTED = 202;
    public static readonly NON_AUTHORITATIVE_INFORMATION = 203;
    public static readonly NO_CONTENT = 204;
    public static readonly RESET_CONTENT = 205;
    public static readonly PARTIAL_CONTENT = 206;
    public static readonly MULTI_STATUS = 207;
    public static readonly ALREADY_REPORTED = 208;
    public static readonly IM_USED = 226;
    public static readonly MULTIPLE_CHOICES = 300;
    public static readonly MOVED_PERMANENTLY = 301;
    public static readonly FOUND = 302;
    public static readonly SEE_OTHER = 303;
    public static readonly NOT_MODIFIED = 304;
    public static readonly USE_PROXY = 305;
    public static readonly TEMPORARY_REDIRECT = 307;
    public static readonly PERMANENT_REDIRECT = 308;
    public static readonly BAD_REQUEST = 400;
    public static readonly UNAUTHORIZED = 401;
    public static readonly PAYMENT_REQUIRED = 402;
    public static readonly FORBIDDEN = 403;
    public static readonly NOT_FOUND = 404;
    public static readonly METHOD_NOT_ALLOWED = 405;
    public static readonly NOT_ACCEPTABLE = 406;
    public static readonly PROXY_AUTHENTICATION_REQUIRED = 407;
    public static readonly REQUEST_TIMEOUT = 408;
    public static readonly CONFLICT = 409;
    public static readonly GONE = 410;
    public static readonly LENGTH_REQUIRED = 411;
    public static readonly PRECONDITION_FAILED = 412;
    public static readonly PAYLOAD_TOO_LARGE = 413;
    public static readonly REQUEST_URI_TOO_LONG = 414;
    public static readonly UNSUPPORTED_MEDIA_TYPE = 415;
    public static readonly REQUESTED_RANGE_NOT_SATISFIABLE = 416;
    public static readonly EXPECTATION_FAILED = 417;
    public static readonly IM_A_TEAPOT = 418;
    public static readonly MISDIRECTED_REQUEST = 421;
    public static readonly UNPROCESSABLE_ENTITY = 422;
    public static readonly LOCKED = 423;
    public static readonly FAILED_DEPENDENCY = 424;
    public static readonly UPGRADE_REQUIRED = 426;
    public static readonly PRECONDITION_REQUIRED = 428;
    public static readonly TOO_MANY_REQUESTS = 429;
    public static readonly REQUEST_HEADER_FIELDS_TOO_LARGE = 431;
    public static readonly CONNECTION_CLOSED_WITHOUT_RESPONSE = 444;
    public static readonly UNAVAILABLE_FOR_LEGAL_REASONS = 451;
    public static readonly CLIENT_CLOSED_REQUEST = 499;
    public static readonly INTERNAL_SERVER_ERROR = 500;
    public static readonly NOT_IMPLEMENTED = 501;
    public static readonly BAD_GATEWAY = 502;
    public static readonly SERVICE_UNAVAILABLE = 503;
    public static readonly GATEWAY_TIMEOUT = 504;
    public static readonly HTTP_VERSION_NOT_SUPPORTED = 505;
    public static readonly VARIANT_ALSO_NEGOTIATES = 506;
    public static readonly INSUFFICIENT_STORAGE = 507;
    public static readonly LOOP_DETECTED = 508;
    public static readonly NOT_EXTENDED = 510;
    public static readonly NETWORK_AUTHENTICATION_REQUIRED = 511;
    public static readonly NETWORK_CONNECT_TIMEOUT_ERROR = 599;
}

/**
 * general
 */

 export const General = class {
     public static readonly LEGACY_SUPPLIER_ID = '__legacy_supplier_id'
 }
